<template>
    <div class="section-1">
        <div :class="visible?'bg gs':'bg'" ref="bgVideoTag">
            <!-- <video :class="index===0?'cur':''" src="./video/1.mp4" muted @ended="videoEnd(0)"></video>
            <video :class="index===1?'cur':''" src="./video/3.mp4" muted @ended="videoEnd(1)"></video>
            <video :class="index===2?'cur':''" src="./video/2.mp4" muted @ended="videoEnd(2)"></video> -->
            <!--  type="application/x-mpegURL"  -->
            <video :class="index===0?'cur':''" id="bgVideo0" muted autoplay>
                <source src="//img.library.sh.cn/hisdata/his/bg1/movie.m3u8" type="application/x-mpegURL" >
            </video>
            <video :class="index===1?'cur':''" id="bgVideo1" muted>
                <source src="//img.library.sh.cn/hisdata/his/bg2/movie.m3u8" type="application/x-mpegURL" >
            </video>
            <video :class="index===2?'cur':''" id="bgVideo2" muted>
                <source src="//img.library.sh.cn/hisdata/his/bg3/movie.m3u8" type="application/x-mpegURL" >
            </video>
        </div>
        <div v-show="showContent" v-if="!visible" :class="frameAnimated?'search-box cur':'search-box'">
            <img v-if="frameAnimated" :src="picFile" alt="" class="slogan">
            <img v-if="frameAnimated" src="../../../assets/images/3.png" alt="" class="corner-mark1">
            <div class="ipt-box certain-category-search-wrapper">
                <!-- :data-source="dataSourceHint" -->
                <a-auto-complete ref="autoComplete"
                    class="certain-category-search"
                    dropdown-class-name="certain-category-search-dropdown"
                    :dropdown-match-select-width="false"
                    :filter-option="filterOption"
                    v-model="searchKeyword"
                    option-label-prop="value"
                    @focus="onFocus"
                    @search="onAutoSearch"
                >
                    <template slot="dataSource">
                        <a-select-opt-group v-for="group in dataSourceHint" :key="group.title">
                            <span slot="label">{{ group.title }}</span>
                            <a-select-option v-for="opt in group.children" :key="opt" :value="opt" :text="opt">
                                {{ opt }}
                            </a-select-option>
                        </a-select-opt-group>
                    </template>
                    <!--  v-model="searchKeyword" -->
                    <input type="text" placeholder="输入关键字搜索" @keyup.enter="search">
                </a-auto-complete>
                <button type="button" @click="search"></button>
                <a href="javascript:" class="more-search" @click="$emit('showSearch')">
                    <span>高级</span>
                    <span>搜索</span>
                </a>
            </div>
            <div class="des">{{Common.description}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            frameAnimated:{
                required:true
            },
            showContent:{
                required:true
            },
            visible:{
                required:true
            },
            navKnowledge:{
                default:0
            },
            focusChange:{
                default:0
            }
        },
        data(){
            return{
                searchKeyword: '',
                dataSourceHint: [
                    {
                        title:'检索框提示',
                        children: [ "李鸿章", "张恨水", "鲁迅", "严独鹤", "啼笑因缘" ]
                    }
                ], // 检索框提示
                picFile:'./frames/logo0828_00120.png',
                timer:null,
                index:-1,
                videos:['./video/BG%20test.mp4','./video/BG%20test2.mp4','./video/BG%20test3.mp4'],
                videoPlayer: null,
                videoPlayer0: null,
                videoPlayer1: null,
                videoPlayer2: null,
                // videoM3U8: [
                //     "//img.library.sh.cn/hisdata/bk/bg1/movie.m3u8",
                //     "//img.library.sh.cn/hisdata/bk/bg2/movie.m3u8",
                //     "//img.library.sh.cn/hisdata/bk/bg3/movie.m3u8"
                // ],
                videoM3U8: [
                    "//img.library.sh.cn/hisdata/his/bg1/movie.m3u8",
                    "//img.library.sh.cn/hisdata/his/bg2/movie.m3u8",
                    "//img.library.sh.cn/hisdata/his/bg3/movie.m3u8"
                ],
                curr: 0, // 循环播放控制
            }
        },
        computed:{
            activeUserInfo(){
                return this.Common.userInfo;
            }
        },
        watch:{
            frameAnimated(){
                if(this.frameAnimated){
                    this.index=0;
                    // document.getElementsByTagName('video')[this.index].play()
                }
            },
            focusChange(){ // 检索框失去焦点
                if(this.focusChange) this.$refs.autoComplete.blur();
            },
        },
        mounted() {
            // 初始化videojs插件
            this.$nextTick(() => {
                this.videoJsLoopPlay();
            })
        },
        methods:{
            filterOption(input, option) { // 检索框提示配置
                let _text = option.componentOptions.children[0].text;
                if(this.isEmpty(_text)) return false;
                return (
                    _text.toUpperCase().indexOf(input.toUpperCase()) >= 0
                );
            },
            onAutoSearch(searchText){ // 检索补全
                console.log('onAutoSearch', searchText);
            },
            onFocus(){ // 检索框获得焦点/鼠标点入检索框
                if(this.activeUserInfo) this.getHisAndRetSearch(this);
            },
            videoEnd(a){
                if(a===2){
                    this.index=2
                }else{
                    this.index++
                }
                // document.getElementsByTagName('video')[this.index].play()
            },
            search(){ // 首页简单检索
                this.$router.push({
                    name:"searchResult", 
                    params:{
                        searchType: 1, 
                        simpleKeyword: this.searchKeyword
                    }
                });
                // this.$router.push({path:"/result", query:{simpleKeyword: JSON.stringify(searchParams)}});
            },
            videoJsLoopPlay(){
                this.videoPlayer0 = this.setVideoJsOptions("bgVideo0");
                this.videoPlayer1 = this.setVideoJsOptions("bgVideo1");
                this.videoPlayer2 = this.setVideoJsOptions("bgVideo2");
                // 视频1开始播放
                // this.videoPlayer0.play();
                // 视频1播放完毕后
                this.videoPlayer0.on("ended", ()=>{
                    this.index = 1;
                    this.videoPlayer1.play();
                })
                // 视频2播放完毕后
                this.videoPlayer1.on("ended", ()=>{
                    this.index = 2;
                    this.videoPlayer2.play();
                })
                // 视频3播放完毕后
                this.videoPlayer2.on("ended", ()=>{
                    this.index = 0;
                    switch (this.curr) {
                        case 0:
                            this.curr  = 1;
                            if(this.curr == 1){
                                // 更换视频地址 type: "application/x-mpegURL"
                                this.videoPlayer0.src({ src: this.videoM3U8[2] })
                                this.videoPlayer1.src({ src: this.videoM3U8[2] })
                                this.curr = -1;
                            }
                            break;
                        default:
                            break;
                    }
                    this.videoPlayer0.play();
                })
            },
            setVideoJsOptions(videoEle){
                const _this  = this;
                // let _video   = document.getElementById(videoEle);
                // 初始化视频方法
                let _videoJs = this.$VideoJs(videoEle, {
                    techOrder: ['html5', 'flash'],
                    language: 'zh-CN',
                    // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                    controls: false,
                    // 自动播放属性, muted:静音播放
                    // autoplay: "muted",
                    // 视频封面
                    // poster: this.videoList[this.current].poster,
                    // 建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                    // preload: "auto",  // "auto"
                    // 设置视频播放器的显示宽度（以像素为单位）
                    width: "100%",
                    // 设置视频播放器的显示高度（以像素为单位）
                    // height: "100%",
                    loop: false, // 是否循环播放
                    bigPlayButton: false,
                    textTrackDisplay: false,
                    posterImage: false, // true
                    errorDisplay: false,
                    playbackRates: [0.25, 0.5, 1, 1.5, 2, 4, 8, 16], //播放倍数
                    hls: {
                        withCredentials: false
                    },
                    // hls: true,  //启用hls？
                    // flash: {
                    //     //swf: '/videojs/video-js.swf'
                    //     //放在static或着public下面文件夹中的videojs文件夹中 当引入js文件中统一定义时此处可省略
                    //     hls: { withCredentials: false },
                    // },
                    // html5: { hls: { withCredentials: false } },
                    // 配置控制栏
                    // controlBar: false,
                    // controlBar: {
                    //     volumePanel: {
                    //             inline: false,          // 音量调节是否水平
                    //     },
                    //     timeDivider: true,              // 时间分割线
                    //     currentTimeDisplay:true,        // 当前播放位置
                    //     durationDisplay: true,          // 总时间
                    //     progressControl: true,          // 进度条
                    //     remainingTimeDisplay: false,    // 剩余时间
                    //     fullscreenToggle: true          // 全屏按钮
                    // }
                }, function() {
                    this.on("loadstart",function(){
                        // console.log("开始请求数据 ");
                    })
                    this.on('progress', function () {
                        // console.log('正在请求数据')
                    })
                    this.on("play", function(){
                        // console.log("视频开始播放")
                    })
                    this.on("ended", function () {
                        // console.log('视频'+_this.index+'播放结束了');
                    })
                    this.on("error", function () {
                        console.log("异常，无法播放")
                    })
                })

                return _videoJs;
            }
        },
        beforeDestroy() {
            clearInterval(this.timer);
            // 销毁 videoJs 实例
            this.videoPlayer0.dispose();
            this.videoPlayer1.dispose();
            this.videoPlayer2.dispose();
        }
    }
</script>


<style>
/* 去掉loading图标 */
.vjs-seeking .vjs-loading-spinner,
.vjs-waiting .vjs-loading-spinner {
    display: none!important;
}

/* 输入框自动完成功能 */
.ant-select-dropdown{
    width: 520px!important;
    background-color: rgba(255, 255, 255, 0.9)!important;
}

.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){
    /* 鼠标悬浮背景色 */
    background-color: rgba(201, 201, 201, 0.3)!important;
}
.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled){
    /* 鼠标悬浮相同的内容背景色 */
    background-color: rgba(201, 201, 201, 0.3)!important;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item-group-title {
  color: #666;
  font-weight: bold;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item-group {
  border-bottom: 1px solid #f6f6f6;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item {
  padding-left: 16px;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item.show-all {
  text-align: center;
  cursor: default;
}

.certain-category-search-dropdown .ant-select-dropdown-menu {
  max-height: 300px;
}
</style>

<style scoped>
/* 输入框自动完成功能 */
.certain-category-search-wrapper
  >>> .certain-category-search.ant-select-auto-complete
  .ant-input-affix-wrapper
  .ant-input-suffix {
  right: 12px;
}
.certain-category-search-wrapper >>> .certain-search-item-count {
  position: absolute;
  color: #999;
  right: 16px;
}
.certain-category-search-wrapper
  >>> .certain-category-search.ant-select-focused
  .certain-category-icon {
  color: #108ee9;
}
.certain-category-search-wrapper >>> .certain-category-icon {
  color: #6e6e6e;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 16px;
}
</style>

<style lang="less" scoped>
    /deep/.ant-select-selection{
        background-color: initial;
    }
    /deep/.ant-select-auto-complete{
        &.ant-select{
            .ant-select-selection__rendered{
                line-height: 40px;
            }
        }
    }
    /deep/.ant-select-combobox{
        .ant-select-search__field__wrap{
            height: 40px;
        }
    }
</style>
